import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Image from 'components/Image';

const SectionIndustries = ({ style, hideLinks }) => (
  <section className="white-bg-section">
    <div className="industries-main" style={style}>
      <div className="container">
        <h2 className="big-heading">
          Industries
          <span className="pink">.</span>
        </h2>
        <div className="industries-block">
          <div className="row">
            <div className="col-md-4">
              <div className="industry-single">
                <span className="industry-floating">Logistics</span>
                <Image src="home/industry-1.jpg" alt="Logistics" />
                <div className="industry-overlay">
                  <h3>Logistics</h3>
                  <p>
                    Customized solutions to your specific needs depending on
                    your role in the supply chain – manufacturer, logistics
                    provider, supplier or retailer, we’ve got you covered.
                    Create value from targeted efficiencies and technologically
                    driven insights.
                  </p>
                  {!hideLinks && (
                    <Link to="/solutions/" className="read-more">
                      <span>
                        LEARN ABOUT OUR SOLUTIONS&nbsp;
                        <i className="far fa-long-arrow-right" />
                      </span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="industry-single">
                <span className="industry-floating">Healthcare</span>
                <Image src="home/industry-2.jpg" alt="Healthcare" />
                <div className="industry-overlay">
                  <h3>Healthcare</h3>
                  <p>
                    At ATC, we recognize that healthcare companies face constant
                    demand for end-user compliance, security and data privacy
                    and rely on their information technology systems to remain
                    competitive.
                  </p>
                  {!hideLinks && (
                    <Link to="/solutions/" className="read-more">
                      <span>
                        LEARN ABOUT OUR SOLUTIONS&nbsp;
                        <i className="far fa-long-arrow-right" />
                      </span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="industry-single">
                <span className="industry-floating">Finance</span>
                <Image src="home/industry-3.jpg" alt="Finance" />
                <div className="industry-overlay">
                  <h3>Finance</h3>
                  <p>
                    Shifting markets, constant innovation, and regulatory
                    scrutiny challenge the revenue growth and operating
                    efficiencies of financial institutions. To operate and scale
                    effectively, they must harness new technologies as quickly
                    as possible to provide the quality services customers
                    demand. We can help.
                  </p>
                  {!hideLinks && (
                    <Link to="/solutions/" className="read-more">
                      <span>
                        LEARN ABOUT OUR SOLUTIONS&nbsp;
                        <i className="far fa-long-arrow-right" />
                      </span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="industry-many-more">
            <h4>and many more...</h4>
            <p>
              Banking / Technology / Education / Automotive / Transportation /
              Retail / Energy / Manufacturing / Insurance / Agriculture /
              Government
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

SectionIndustries.propTypes = {
  style: PropTypes.object,
  hideLinks: PropTypes.bool,
};

export default SectionIndustries;
